import { render, staticRenderFns } from "./en-sentenceAddPage.vue?vue&type=template&id=f1633472&scoped=true&"
import script from "./en-sentenceAddPage.vue?vue&type=script&lang=js&"
export * from "./en-sentenceAddPage.vue?vue&type=script&lang=js&"
import style0 from "./en-sentenceAddPage.vue?vue&type=style&index=0&id=f1633472&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1633472",
  null
  
)

export default component.exports